module.exports = __webpack_public_path__ + "f1e9f1b41e4640957f8ce436dd3264bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/campbell_soup_2022_chart.png
// module id = 1643
// module chunks = 0